import { ComponentType, FC, LazyExoticComponent, ReactNode, Suspense } from "react";
import LazyLoading from "@/components/basic/lazy-import/lazy-loading";

interface LazyImportProps {
  lazy?: LazyExoticComponent<ComponentType>;
}

export const LazyImport: FC<LazyImportProps> = ({ lazy }) => {
  const Component = lazy ? lazy : () => null as ReactNode;
  return (
    <Suspense fallback={<LazyLoading />}>
      <Component />
    </Suspense>
  );
};
